module.exports = __webpack_public_path__ + "img/27.f92f7041.png";